/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ used: NonNullable<unknown> }} Usage_Tab_Budget_Used_UnlimitedInputs */



/**
* | output |
* | --- |
* | "{used} of ∞ used this period" |
*
* @param {Usage_Tab_Budget_Used_UnlimitedInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const usage_tab_budget_used_unlimited = /** @type {((inputs: Usage_Tab_Budget_Used_UnlimitedInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Usage_Tab_Budget_Used_UnlimitedInputs, { locale?: "en" | "de" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ (`${i?.used} von ∞ in diesem Zeitraum verbraucht`)
	return /** @type {LocalizedString} */ (`${i?.used} of ∞ used this period`)
});